import { transport } from 'config/transport';

export function callApiExportDangKiMonHoc(congDoanId, classId) {
    return transport.get(`/mamnon/${congDoanId}/thuhocsinh/${classId}/dangky/report`, { responseType: 'blob' });
}
